(function($, viewport) {
  $(function() {
    // =========================================
    // sticky nav
    // =========================================

    //$('#main-header').stick_in_parent();

    // =========================================
    // Detect for OLD Android device is < 4.4
    // so offcanvas nav can be handled properly
    // =========================================

    var md = new MobileDetect(window.navigator.userAgent);
    var device = md.os();
    var osVersion = md.version('Android');

    if (device == 'AndroidOS' && osVersion < 4.4) {
      $('body').addClass('old-android');
    } else {
      // do nothing
    }

    // =========================================
    // Prevent default on hamburger
    // =========================================

    $('#small-screen-menu-button a').click(function(e) {
      e.preventDefault();
    });

    // =========================================
    // Execute on initial load
    // =========================================

    // =========================================
    // BEGIN - bootstrap breakpoints
    // =========================================

    // Executes only in XS breakpoint
    // if (viewport.is('xs')) {
    //   // ...
    // }

    // // Executes in SM, MD and LG breakpoints
    // if (viewport.is('>=sm')) {
    //   // ...
    // }

    // // Executes in XS and SM breakpoints
    // if (viewport.is('<md')) {
    //   // ...
    // }

    // Execute code each time window size changes
    // $(window).resize(
    //   viewport.changed(function() {
    //     if (viewport.is('>=md')) {
    //       // ...
    //     }

    //     if (viewport.is('>sm')) {
    //       // ...
    //     }
    //   })
    // );
  });
})(jQuery, ResponsiveBootstrapToolkit);